import { AcademicYearType } from "../../../types/AcademicYear";
import { put } from "../../../utils/axios-config";
import { ACADEMICYEARS } from "../../../utils/constants";

export const updateAcademicYear = async (data: AcademicYearType) => await put<AcademicYearType, boolean>(ACADEMICYEARS, data);